module.exports = __webpack_public_path__ + "img/CellCycle-OVCA_10X_TIP.e0a31764.png";